<template>
  <v-layout>
    <component
      :is="catalogItemsComponent"
      @openOptionsDialog="openOptionsDialog"
    />
    <v-snackbar
      color="error"
      :timeout="5000"
      :bottom="true"
      v-model="_showError"
    >
      {{_error}}
      <v-btn flat icon @click.native="_showError = false; _setError(false)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import catalogItemsTable from './CatalogItemsTable'
import catalogItemsList from './CatalogItemsList'

export default {
  name: 'CatalogItems',
  components: {
    catalogItemsTable,
    catalogItemsList
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _error: 'error'
    }),
    ...mapFields('catalog', {
      _showError: 'showError'
    }),
    catalogItemsComponent () {
      return this.$vuetify.breakpoint.smAndDown ? 'catalog-items-list' : 'catalog-items-table'
    }
  },
  methods: {
    openOptionsDialog (item) {
      this.$emit('openOptionsDialog', item)
    }
  }
}
</script>

<style scoped>

</style>
